import { ChevronLeft } from "@tamagui/lucide-icons";
import type { ReactNode } from "react";
import { XStack, YStack, useMedia } from "tamagui";

import { Button, Heading, ScrollView } from "@/components";
import { ZocdocLogo } from "./ZocdocLogo";

const TOTAL_STEPS = 6;

type PhaseContainerProps = {
  title?: string;
  currentStep: number;
  onBack?: () => void;
  children: ReactNode;
};

export const PhaseContainer = ({
  title,
  currentStep,
  onBack,
  children,
}: PhaseContainerProps) => {
  const progress = Math.max(0, Math.min(1, currentStep / TOTAL_STEPS));
  const { maxLg } = useMedia();
  return (
    <YStack gap="$300" $maxLg={{ gap: "$200" }} flex={1}>
      <XStack alignItems="center">
        <XStack flexGrow={1} flexBasis={0} justifyContent="flex-start">
          {onBack && (
            <Button
              mode="tertiary"
              onPress={onBack}
              icon={<ChevronLeft size={20} />}
              aria-label="Back"
              dataTrackingId="zocdoc-phase-back"
            />
          )}
        </XStack>
        <ZocdocLogo />
        <XStack flexGrow={1} flexBasis={0} />
      </XStack>
      <YStack
        height={4}
        backgroundColor="$strokeNeutral"
        borderRadius={2}
        overflow="hidden"
      >
        <YStack
          width={`${progress * 100}%`}
          height="100%"
          backgroundColor="$fillButtonPrimary"
        />
      </YStack>
      <ScrollView
        flex={1}
        minHeight={0}
        contentContainerStyle={{ gap: maxLg ? "$200" : "$300" }}
      >
        {title && <Heading size="$md">{title}</Heading>}
        {children}
      </ScrollView>
    </YStack>
  );
};
